import React, { useState, useContext } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { FaEnvelope, FaLock, FaSignInAlt, FaEye, FaEyeSlash } from "react-icons/fa";
import API_URL from "../config";
import axios from "axios";
import "./Login.css";
import { AuthContext } from "./AuthContext";

export default function Login() {
const navigate = useNavigate();
const { user, login } = useContext(AuthContext);

const [email, setEmail] = useState("");
const [password, setPassword] = useState("");
const [loading, setLoading] = useState(false);
const [showPassword, setShowPassword] = useState(false);

if (user?.token) {
return <Navigate to="/home" replace />;
}

const handleLogin = async (e) => {
e.preventDefault();
if (!email || !password) {
alert("Veuillez remplir tous les champs !");
return;
}

try {
  setLoading(true);
  const res = await axios.post(`${API_URL}/api/entreprise/login`, {
    email,
    mot_de_passe: password,
  });

  if (res.data?.token) {
    login(res.data.token);

    console.log("🔑 [Login] token reçu :", res.data.token);
    const payload = JSON.parse(atob(res.data.token.split(".")[1]));
    console.log("🏢 entrepriseId :", payload.entrepriseId);
    console.log("👤 typeUser :", payload.type_user);
    console.log(
      "🆔 gestionnaireId (si gestionnaire) :",
      payload.type_user === "gestionnaire" ? payload.id : null
    );
    console.log("📂 payload complet :", payload);

    navigate("/home", { replace: true });
  } else {
    alert("Réponse inattendue du serveur.");
  }
} catch (error) {
  console.error("❌ Erreur login :", error);
  if (error.response?.data?.message) {
    alert(error.response.data.message);
  } else {
    alert("❌ Erreur serveur, réessayez plus tard");
  }
} finally {
  setLoading(false);
}


};

return ( <div className="login-container"> <div className="login-card"> <h1>Connexion</h1> <p>Accédez à votre espace de gestion</p>


    <form onSubmit={handleLogin} className="login-form">
      <div className="input-group">
        <FaEnvelope className="icon" />
        <input
          type="email"
          placeholder="Adresse email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="username"
        />
      </div>

      <div className="input-group password-group">
        <FaLock className="icon" />
        <input
          type={showPassword ? "text" : "password"}
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
        />
        <span
          className="toggle-password"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </span>
      </div>

      <button type="submit" className="btn-login" disabled={loading}>
        {loading ? "Connexion..." : (
          <>
            <FaSignInAlt /> Se connecter
          </>
        )}
      </button>
    </form>

    <p
      className="forgot-link"
      style={{
        marginTop: "20px",
        textAlign: "center",
      }}
    >
      <span
        onClick={() => navigate("/forgot-password")}
        style={{ color: "#007bff", cursor: "pointer" }}
      >
        Mot de passe oublié ?
      </span>
    </p>

    <p
      className="register-link"
      style={{
        marginTop: "10px",
        textAlign: "center",
      }}
    >
      Pas encore de compte ?{" "}
      <span
        onClick={() => navigate("/register")}
        style={{ color: "#007bff", cursor: "pointer" }}
      >
        S’inscrire
      </span>
    </p>
  </div>
</div>


);
}
